import { manufacturingFetch } from "@/lib/manufacturingClient";

export type MfgBuiltUnitSummary = {
  id: string;
  plant_id: string;
  mfg_unit_id: string | null;
  serial_number: string;
  deal_id: string | null;
  snapshot_id: string | null;
  status: string;
  build_started_at: string | null;
  build_completed_at: string | null;
};

export type MfgBuiltUnitStartBuildResponse = {
  ok: true;
  built_unit: MfgBuiltUnitSummary;
  mfg_unit_id: string | null;
  event_id: string;
};

export type MfgBuiltUnitCompleteBuildResponse = {
  ok: true;
  built_unit: MfgBuiltUnitSummary;
  production_dollars_usd: number;
  event_id: string;
};

export function startManufacturingBuiltUnitBuild(payload: {
  mfg_unit_id?: string;
  deal_id?: string;
  plant_id?: string;
  serial_number?: string;
}) {
  return manufacturingFetch<MfgBuiltUnitStartBuildResponse>("/api/mfg/built-units/start-build", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function completeManufacturingBuiltUnitBuild(payload: {
  built_unit_id?: string;
  mfg_unit_id?: string;
  build_cost_usd?: number;
  event_at?: string;
}) {
  return manufacturingFetch<MfgBuiltUnitCompleteBuildResponse>("/api/mfg/built-units/complete-build", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
